import { useAuth0 } from "@auth0/auth0-react"
import { useAppSelector, useAppDispatch } from "../../app/hooks"
import { loadNotificationAsync, markAsViewedNotificationAsync, removeNotificationAsync, selectFilteredNotifications, selectNotifications, selectNotificationsDisplayFilter, selectNotificationsFilter, selectNotificationSortDescending, selectRefreshIsRequired, setNewNotificationReceived, setNotificationsDisplayFilter, setNotificationsFilter, setNotificationSortDescending } from "./notificationsSlice"
import { useNavigate } from "react-router-dom"
import { useMenuPanel } from "../../MenuPanelContext"
import { resetButtons, setBackButtonVisible, setInformationButtonVisible, setNotificationReloadButton, setReloadButtonVisible } from "../menu/menuSlice"
import { useEffect } from "react"
import { setInvitationReference } from "../invitation/invitationSlice"
import { Page } from "../../Page"
import styles from './notifications.module.css'
import { sanitizeEmail } from "../../utils/emailUtils"
import { DownIcon, SearchIcon, UpIcon } from "../../images/Icons"
import { BackButton } from "../menu/BackButton"

export function Notifications() {
    const { user, isAuthenticated, getAccessTokenSilently} = useAuth0()
    const dispatch = useAppDispatch()
    const displayFilter = useAppSelector(selectNotificationsDisplayFilter)
    const notifications = useAppSelector(selectNotifications)
    const notificationsFilter = useAppSelector(selectNotificationsFilter)
    const filteredNotifications = useAppSelector(selectFilteredNotifications)
    const notificationSortDescending = useAppSelector(selectNotificationSortDescending)
    const refreshIsRequired = useAppSelector(selectRefreshIsRequired)
    
    const navigate = useNavigate()


    const menuPannelRef = useMenuPanel()
    useEffect(() => {
        dispatch(resetButtons())
        dispatch(setBackButtonVisible(true))
        dispatch(setNotificationReloadButton(true))
        dispatch(setInformationButtonVisible(true))
    }, [dispatch])

    useEffect(() => {
        const getUserMetaData = async () => {
            if (isAuthenticated){ 
                try {
                    const accessToken = await getAccessTokenSilently({ authorizationParams : {
                    }})
                    if (user?.email) {
                    if (refreshIsRequired) {
                        dispatch(loadNotificationAsync({
                            email: sanitizeEmail(user?.email),
                            token: accessToken
                        }))
                    }
                        dispatch(setNewNotificationReceived(false))
                        notifications.map((notification ) =>
                        {
                            if (!notification.viewed && user?.email != null) {
                                dispatch(markAsViewedNotificationAsync({
                                    email: sanitizeEmail(user.email),
                                    token: accessToken,
                                    notificationId: notification.id
                                }))
                            }
                        })
                    }
                }
                catch (error) {}
            }
        };
    

        getUserMetaData();

    }, [dispatch, getAccessTokenSilently, isAuthenticated, menuPannelRef, navigate, user?.email, setInvitationReference, refreshIsRequired ]);
        return (
            <Page>
            {isAuthenticated ? 
            <>
            <div className={styles.bannerContainer}>
                <div>
                <h2>PartyPlanner.</h2>
                <h4>Organise, invite and celebrate in style.</h4>
                </div>
                <div className={styles.bannerButton}>
                    <BackButton/>
                </div>
            </div>
                <div className={styles.titleContainer}>
                    <h1>Notifications</h1>
                    <br></br>
                    <div className={styles.arrowContainer}>
                {/* { notificationSortDescending ? 
                    <div className={styles.UpButton} onClick={() => {
                        dispatch(setNotificationSortDescending(false))}}>
                        <UpIcon/>
                    </div>
                    : 
                    <div className={styles.DownButton} onClick = {()=> {
                        dispatch(setNotificationSortDescending(true)) }}>
                        <DownIcon/>
                        </div>
                } */}
                </div>
                    </div>
                    </> : null}

              <span>
                <div className={styles.filterContainer}>
                    <input
                        size={65}
                        autoFocus
                        type= 'text'
                        className={styles.searchFilter}
                        value={notificationsFilter}
                        placeholder='Search'
                        onChange={(e) => {
                            dispatch(setNotificationsFilter(e.target.value))
                        }}>
                        </input>
                        </div> 
            </span>
                {
                    isAuthenticated && filteredNotifications?.map((notification) =>
                        <>
                        <div key={notification.id} className={styles.notificationDiv}>
                            <div className={styles.notificationMessage}>
                                <h2>{notification.message}</h2>
                                <br></br>
                                <button className={styles.deleteNotifications} onClick={async (e) => {
                                    e.stopPropagation()
                                    if (isAuthenticated ) {
                                        try {
                                            const accessToken = await getAccessTokenSilently({ authorizationParams : {
                                            }})
                                            if (user?.email) {
                                                dispatch(removeNotificationAsync({
                                                    email: sanitizeEmail(user?.email),
                                                    notificationId: notification.id,
                                                    token: accessToken
                                                }))
                                            }
                                        }
                                        catch (error) {}
                                    }
                                }}>Delete</button>
                            </div>            
                            </div>
                            </>
                    )
                }
                <br></br>
                <br></br>
                <br></br>
            </Page>
        )
}